import React from "react";
import { each, map } from "lodash";
import TrackRow from "./TrackRow";
import TrackEditableRow from "./TrackEditableRow";

class Track extends React.Component {
  constructor(props) {
    super(props);
    this.toggleVersionsExpanded = this.toggleVersionsExpanded.bind(this);

    this.editMode = window.HIFI_APP.HIFI_EDIT_MODE;
    this.trackComponent = this.editMode ? TrackEditableRow : TrackRow;

    this.state = {
      versionsExpanded: false,
    };
  }

  toggleVersionsExpanded() {
    const { versionsExpanded } = this.state;

    this.setState({
      versionsExpanded: !versionsExpanded,
    });
  }

  render() {
    const {
      track,
      playingTrack,
      addingTrack,
      energyDisplayColumn,
      shapeDisplayColumn,
      selectedTracks,
    } = this.props;
    const { versionsExpanded } = this.state;

    let _versionsExpanded = versionsExpanded;

    let versionNumber = 0;
    const versionItems = map(track.versions, (version) => {
      versionNumber++;
      each(track._highlightResult.versions, (highlightResultVersion) => {
        if (
          "full" === highlightResultVersion.hifi_song_version_title.matchLevel
        ) {
          _versionsExpanded = true;
        }
      });

      const versionHighlightResults =
        track._highlightResult.versions[versionNumber - 1]
          .hifi_song_version_title;
      return React.createElement(this.trackComponent, {
        key: `${track.objectID}-${versionNumber}`,
        track,
        playingTrack,
        addingTrack,
        energyDisplayColumn,
        shapeDisplayColumn,
        version,
        versionNumber,
        versionsExpanded: _versionsExpanded,
        isSelected:
          "undefined" !==
          typeof selectedTracks[`${track.objectID}-${versionNumber}`],
        versionHighlightResults,
        toggleVersionsExpanded: this.toggleVersionsExpanded,
      });
      // <TrackRow
      //   key={`${track.objectID}-${versionNumber}`}
      //   track={track}
      //   playingTrack={playingTrack}
      //   addingTrack={addingTrack}
      //   energyDisplayColumn={energyDisplayColumn}
      //   shapeDisplayColumn={shapeDisplayColumn}
      //   version={version}
      //   versionNumber={versionNumber}
      //   versionsExpanded={_versionsExpanded}
      //   versionHighlightResults={versionHighlightResults}
      //   toggleVersionsExpanded={this.toggleVersionsExpanded}
      // />
    });

    return <React.Fragment>{versionItems}</React.Fragment>;
  }
}

export default Track;
